import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import useWindowSize from 'components/custom-hooks/useWindowSize'
import ShopNowButton from 'components/ttb-home/ttb-shopnow/shopnow-button'
import Typo from 'constants/typography'
import { withI18next } from 'lib/i18n/withI18next'
import { hasLocizeTranslation } from 'lib/utils/locize'
import TTBH_PRODUCT from './const'
import ProductSection from './product-section'
import styles from './style.scss'

const TTBProduct = ({ t }) => {
  const windowWidth = useWindowSize().width

  return (
    <div className="ttb-product__wrapper">
      <style jsx>{styles}</style>
      <div className="ttb-product__title">
        <span className={clsx('ttb-product__title-text', Typo.h4)}>
          {hasLocizeTranslation(
            t,
            TTBH_PRODUCT.disabledKey,
            TTBH_PRODUCT.value,
          )}
        </span>
      </div>
      <ProductSection />
      {windowWidth >= 768 && <ShopNowButton />}
    </div>
  )
}

TTBProduct.propTypes = {
  t: PropTypes.func.isRequired,
}

export default withI18next()(TTBProduct)
